var _linearGradient, _path, _linearGradient2, _rect, _rect2, _rect3, _path2, _rect4, _rect5, _linearGradient3, _path3, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Garagedoorrepair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NQnC9t8FNG9m8kA1Pa5S4a",
    x1: 24,
    x2: 24,
    y1: 1646.939,
    y2: 1684.939,
    gradientTransform: "translate(0 -1642)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbc1c4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#NQnC9t8FNG9m8kA1Pa5S4a)",
    d: "M40,43H8c-1.105,0-2-0.895-2-2V15L24,5l18,10v26C42,42.105,41.105,43,40,43z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NQnC9t8FNG9m8kA1Pa5S4b",
    x1: 24,
    x2: 24,
    y1: 732.665,
    y2: 716.956,
    gradientTransform: "translate(0 -690)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#393c40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#35383c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471,
    stopColor: "#2d3033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b2e30"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 16,
    x: 9,
    y: 27,
    fill: "url(#NQnC9t8FNG9m8kA1Pa5S4b)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 2,
    x: 9,
    y: 29,
    fill: "#64717c"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 2,
    x: 9,
    y: 25,
    fill: "#64717c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M39,23H9v-1c0-0.552,0.448-1,1-1h28c0.552,0,1,0.448,1,1V23z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 2,
    x: 9,
    y: 23,
    fill: "#889097"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 2,
    x: 9,
    y: 27,
    fill: "#889097"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NQnC9t8FNG9m8kA1Pa5S4c",
    x1: 23.999,
    x2: 23.999,
    y1: 1645.049,
    y2: 1658.827,
    gradientTransform: "translate(0 -1642)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0176d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16538c"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#NQnC9t8FNG9m8kA1Pa5S4c)",
    d: "M41.654,17.096L24,7.288L6.346,17.096c-0.483,0.268-1.092,0.094-1.36-0.388l-0.972-1.749 c-0.268-0.483-0.094-1.092,0.388-1.36l18.14-10.078c0.906-0.503,2.008-0.503,2.914,0l18.14,10.078 c0.483,0.268,0.657,0.877,0.388,1.36l-0.972,1.749C42.746,17.191,42.137,17.365,41.654,17.096z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 20,
    y: 29,
    fill: "#323538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Garagedoorrepair);
export default __webpack_public_path__ + "static/media/icons8-garagedoorrepair.723db1f8a461e2f8eade96c421e53e70.svg";
export { ForwardRef as ReactComponent };